/**
 * 帮助对话框模块开关配置
 * 集中管理各个页面的帮助弹窗展示控制
 * 
 * 使用说明：
 * - HELP_DIALOG_ENABLED_CONFIG: true/false 控制帮助弹窗和问号入口的显示/隐藏
 * - PAGE_KEYS: 页面唯一标识，用于区分不同页面的帮助配置
 * 
 * 修改配置后需要重启开发服务器才能生效
 */

// 页面标识常量
export const PAGE_KEYS = {
  FOLLOW: 'FOLLOW',      // 客户跟进
  SENDING: 'SENDING'     // 群发营销
}

// 帮助弹窗启用状态配置
// true: 启用（展示帮助弹窗和入口） | false: 禁用（隐藏帮助弹窗和入口）
export const HELP_DIALOG_ENABLED_CONFIG = {
  [PAGE_KEYS.FOLLOW]: false,   // 客户跟进 - 功能说明帮助模块
  [PAGE_KEYS.SENDING]: false   // 群发营销 - 功能说明帮助模块
}
